import React from 'react';
import { View } from 'react-native';

import Text from '../../../components/text/Text';
import { PrimaryButton, Sheet } from '../../../design/components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import BriefHtml from './BriefHtml';

// Briefs longer than this (in visible characters) open the sheet full height.
const LONG_BRIEF_LENGTH = 400;

/**
 * Today's run brief as a slide-up sheet (Start of day "Read run brief" and
 * its Reopen row, On the run "Run brief"). Long briefs open full height.
 * Props:
 * - isVisible, onClose
 * - serviceRun: { brief (HTML), briefAcknowledgedAt, route }
 * - requireAcknowledgement: show "I've read the brief" until acknowledged
 * - onAcknowledge, isAcknowledging, disabled (training offline)
 */
const BriefSheet = ({
	isVisible,
	onClose,
	serviceRun,
	requireAcknowledgement,
	onAcknowledge,
	isAcknowledging,
	disabled,
}) => {
	const styles = useThemedStyles(createStyles);
	const brief = serviceRun?.brief || '';
	const isLong = brief.replace(/<[^>]*>/g, '').length > LONG_BRIEF_LENGTH;
	const showAcknowledge = Boolean(requireAcknowledgement && !serviceRun?.briefAcknowledgedAt);

	return (
		<Sheet
			isVisible={isVisible}
			onClose={onClose}
			title="Today's run brief"
			fullHeight={isLong}
			footer={(
				<View style={styles.footer}>
					<Text style={styles.note}>You can reopen the brief any time.</Text>
					{showAcknowledge ? (
						<PrimaryButton
							label="I've read the brief"
							onPress={onAcknowledge}
							loading={isAcknowledging}
							disabled={disabled}
						/>
					) : (
						<PrimaryButton label="Close" onPress={onClose} />
					)}
				</View>
			)}
		>
			{Boolean(serviceRun?.route?.name) && <Text style={styles.subheading}>{serviceRun.route.name}</Text>}
			<View style={styles.briefCard}>
				<BriefHtml html={brief} />
			</View>
		</Sheet>
	);
};

const createStyles = ({ ui: { colors, radius, space, type } }) => ({
	subheading: {
		...type.secondary,
		color: colors.textSecondary,
	},
	briefCard: {
		padding: space.lg,
		borderRadius: radius.hero,
		backgroundColor: colors.card,
	},
	footer: {
		gap: space.md,
	},
	note: {
		...type.caption,
		color: colors.textSecondary,
	},
});

export default BriefSheet;
